import React, { useState, useEffect } from "react";

import UserProfileForm from "../../components/UserProfile/UserProfileForm";
import UserProfileView from "../../components/UserProfile/UserProfileView";
import UsersAPI from "../../API/users.api";

const UserProfile = () => {
    const [editMode, setEditMode] = useState(false);
    const [user, setUser] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!editMode) {
            fetchData();
        }
    }, [editMode]);

    const fetchData = async () => {
        try {
            setIsLoading(true);
            const result = await UsersAPI.getUserWithoutId();
            setUser(result);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <>
            {editMode ? (
                <UserProfileForm user={user} setEditMode={setEditMode} />
            ) : (
                <UserProfileView
                    user={user}
                    setEditMode={setEditMode}
                    isLoading={isLoading}
                />
            )}
        </>
    );
};

export default UserProfile;
